module.exports = __webpack_public_path__ + "img/join4-5-h.2270086e.svg";